import React from 'react';
import { Container } from './styles';

// Style can be light or dark
const BurgerMenu = ({onClick, className, dark}) => <Container className={className} onClick={onClick} dark={dark} />;

export default BurgerMenu;